const styles = theme => ({
  hidden: {
    visibility: 'hidden',
  },
});

export default styles;
